import { View } from "react-native";
import React from "react";
import { useFetchAgreementsQuery } from "queries/cms.queries";
import Button from "components/Button";
import { openBrowserAsync } from "expo-web-browser";
import { ViewProps } from "react-native-svg/lib/typescript/fabric/utils";
import tailshake from "tailshake";
import { Text } from "@ui-kitten/components";

const Terms = ({
  tenantSubdomain,
  ...rest
}: { tenantSubdomain: string } & ViewProps) => {
  const { data } = useFetchAgreementsQuery(tenantSubdomain);

  return (
    <View
      className={tailshake("px-4 md:px-16 py-4 bg-transparent", rest.className)}
      {...rest}
    >
      {data?.agreementDetails?.map((agreement) => (
        <Button
          key={agreement._key}
          appearance="ghost"
          style={{ alignSelf: "center" }}
          onPress={() => openBrowserAsync(agreement.url)}
        >
          {() => <Text status="control">{agreement.name}</Text>}
        </Button>
      ))}
    </View>
  );
};

export default Terms;
